import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_40ad2524-223c-429c-8f1d-4ea2ecf9a2d3/artifacts/6n4i34v7_logo.png";

const links = [
  { to: "/", label: "Verifica" },
  { to: "/guida", label: "Guida Anti-Truffe" },
  { to: "/blog", label: "Blog" },
  { to: "/numeri-utili", label: "Numeri Utili" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/contatti", label: "Contatti" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/95 backdrop-blur-xl border-b-2 border-[#1E3A8A]/10 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 md:h-24">
          <Link
            to="/"
            data-testid="header-logo-link"
            className="flex items-center gap-3"
            onClick={() => setOpen(false)}
          >
            <img
              src={LOGO_URL}
              alt="ScudoNonni"
              className="h-14 md:h-16 w-auto"
              data-testid="header-logo-img"
            />
            <div className="hidden sm:flex flex-col leading-tight">
              <span className="font-heading text-2xl font-extrabold text-[#1E3A8A]">
                Scudo<span className="text-[#22C55E]">Nonni</span>
              </span>
              <span className="text-sm text-gray-600 font-medium">
                Ti protegge, ti fa stare sereno
              </span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`nav-link-${l.to.replace(/\//g, "") || "home"}`}
                className={({ isActive }) =>
                  `text-base xl:text-lg font-semibold px-3 xl:px-4 py-2 rounded-xl transition-colors ${
                    isActive
                      ? "bg-[#1E3A8A] text-white"
                      : "text-[#1E3A8A] hover:bg-[#DBEAFE]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <button
            type="button"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-3 rounded-xl border-2 border-[#1E3A8A]/20 text-[#1E3A8A]"
            aria-label="Apri menu"
          >
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {open && (
          <nav className="lg:hidden pb-4 flex flex-col gap-2">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.to.replace(/\//g, "") || "home"}`}
                className={({ isActive }) =>
                  `text-lg font-semibold px-5 py-4 rounded-2xl transition-colors ${
                    isActive
                      ? "bg-[#1E3A8A] text-white"
                      : "text-[#1E3A8A] bg-blue-50 hover:bg-[#DBEAFE]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}
